export default __webpack_public_path__ + "static/media/right.0a640842.png";